import type { FormSchemaResolved } from '#layers/block-engine/public';
import { isRecord } from '#layers/base/public';
import { mapFormSchemaEntries } from '#layers/block-engine/public';

/**
 * Disable browser autocomplete across a resolved form schema. Stale browser
 * credentials in app/client secret fields would hurt more than help.
 */
export function withAutocompleteOff(items: FormSchemaResolved): FormSchemaResolved {
	return mapFormSchemaEntries(items, (item) => {
		let next = item;
		const props = 'props' in next ? next.props : undefined;

		if (hasNestedSchemaProps(props)) {
			next = {
				...item,
				props: {
					...props,
					schema: withAutocompleteOff(props.schema),
				},
			};
		}

		if (!('name' in next) || !next.name) return next;

		const fieldProps = 'props' in next ? next.props : undefined;

		return {
			...next,
			props: {
				...fieldProps,
				autocomplete: 'off',
			},
		};
	});
}

/**
 * Check whether field props carry another FormSchema to recurse into.
 */
function hasNestedSchemaProps(props: unknown): props is Record<string, unknown> & { schema: FormSchemaResolved } {
	return isRecord(props) && 'schema' in props && Array.isArray(props.schema);
}
